import { customFontFamily } from "@redotech/redo-model/brand-kit";
import * as z from "zod";

export const processFontFiles = {
  name: "processFontFiles" as const,
  input: z.object({
    fontUrls: z.array(
      z.object({ url: z.string(), name: z.string().optional() }),
    ),
  }),
  output: z.object({ fontFamilies: z.array(customFontFamily) }),
};
